 import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./common/redux/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import 'react-toastify/dist/ReactToastify.css';

const root = createRoot(document.getElementById("root")!);

root.render(
  <BrowserRouter>
    <Provider store={store}> 
      <App />
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
